import type { AddEthereumChainParameter } from '@web3-react/types'

// FIXME: Should come from @nsfw-app/crypto
import { CHAINS } from 'config/chains'
import { Network } from '@nsfw-app/crypto'
import { utils } from 'ethers'

export interface NetworkListItem {
  id: Network
  name: string
  symbol: string
}

export type NetworkList = NetworkListItem[]

interface BasicChainInformation {
  urls: string[]
  name: string
  nativeCurrency: AddEthereumChainParameter['nativeCurrency']
}

export interface ExtendedChainInformation extends BasicChainInformation {
  blockExplorerUrls: AddEthereumChainParameter['blockExplorerUrls']
  default?: boolean
}

export interface AddChainParameter extends Omit<AddEthereumChainParameter, 'chainId'> {
  // Should be string (hex decimal) as per https://docs.metamask.io/guide/rpc-api.html#wallet-addethereumchain
  chainId: string
}

export type ChainListItem = BasicChainInformation | ExtendedChainInformation

export interface ChainList {
  // note: js object keys are stringified
  [chainId: string]: ChainListItem
}

export interface ChainIdUrls {
  // note: js object keys are stringified
  [chainId: string]: BasicChainInformation['urls']
}

export const hasExtendedChainInfo = (chain: ChainListItem): chain is ExtendedChainInformation => {
  return 'blockExplorerUrls' in chain
}

export const isValidChain = (chainId?: number | string) => {
  console.log('---- isValidChain -----', chainId)
  if (!chainId) return false

  let _chainId = String(chainId)

  if (_chainId.includes('eip155:')) {
    _chainId = _chainId.replace('eip155:', '')
  }

  console.log(Object.keys(CHAINS))
  console.log(Object.keys(CHAINS).includes(String(_chainId)))

  return Object.keys(CHAINS).includes(String(_chainId))
}

/**
 * Given all supported chains, return the default chainId
 *
 * @returns chainId
 */
export const getDefaultChainId = () => {
  const defaultChainId = Object.keys(CHAINS).find(
    (chainId) => (CHAINS[chainId] as ExtendedChainInformation)?.default === true
  )

  // If default is not explict, return first in supported chains list
  if (!defaultChainId) {
    return Number(Object.keys(CHAINS)[0])
  }

  return Number(defaultChainId)
}

export const getChainById = (chainId: string | number) => CHAINS[chainId]

export const getAddChainParams = (chainId: any): AddChainParameter => {
  const chain = CHAINS[chainId]
  return {
    chainId: utils.hexValue(parseInt(chainId)),
    chainName: chain.name,
    rpcUrls: chain.urls,
    nativeCurrency: chain.nativeCurrency,
    ...(hasExtendedChainInfo(chain)
      ? {
          blockExplorerUrls: chain.blockExplorerUrls
        }
      : {})
  }
}

// FIXME: What does this do
export const URLS = Object.keys(CHAINS).reduce<ChainIdUrls>((accumulator, chainId) => {
  const validURLs: string[] = CHAINS[Number(chainId)].urls
  if (validURLs.length) {
    accumulator[Number(chainId)] = validURLs
  }
  return accumulator
}, {})
